/**
 * @generated SignedSource<<c3c56fbeeb731614b7c139fdcef904c3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AnalyticsTimeResolution = "DAY" | "MONTH" | "QUARTER" | "WEEK";
export type WorkspaceRoutineStatusOverviewQuery$variables = {
  routineWorkspaceId: string;
  timeResolution: AnalyticsTimeResolution;
  workspaceId: string;
};
export type WorkspaceRoutineStatusOverviewQuery$data = {
  readonly routineWorkspace: {
    readonly completionDimensions: ReadonlyArray<{
      readonly completedCount: number;
      readonly label: string;
      readonly startedCount: number;
      readonly totalCount: number;
      readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRoutineStatusOverviewListItem_dimension">;
    }> | null;
  } | null;
};
export type WorkspaceRoutineStatusOverviewQuery = {
  response: WorkspaceRoutineStatusOverviewQuery$data;
  variables: WorkspaceRoutineStatusOverviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "routineWorkspaceId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "timeResolution"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "workspaceId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "routineWorkspaceId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "timeResolution",
    "variableName": "timeResolution"
  },
  {
    "kind": "Variable",
    "name": "workspaceId",
    "variableName": "workspaceId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completedCount",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startedCount",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceRoutineStatusOverviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RoutineWorkspace",
        "kind": "LinkedField",
        "name": "routineWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "RoutineWorkspaceCompletionDimension",
            "kind": "LinkedField",
            "name": "completionDimensions",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WorkspaceRoutineStatusOverviewListItem_dimension"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceRoutineStatusOverviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RoutineWorkspace",
        "kind": "LinkedField",
        "name": "routineWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "RoutineWorkspaceCompletionDimension",
            "kind": "LinkedField",
            "name": "completionDimensions",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2d12c9f7ff5d60fffa4ee4981649a0f1",
    "id": null,
    "metadata": {},
    "name": "WorkspaceRoutineStatusOverviewQuery",
    "operationKind": "query",
    "text": "query WorkspaceRoutineStatusOverviewQuery(\n  $routineWorkspaceId: ID!\n  $timeResolution: AnalyticsTimeResolution!\n  $workspaceId: ID!\n) {\n  routineWorkspace(id: $routineWorkspaceId) {\n    completionDimensions(timeResolution: $timeResolution, workspaceId: $workspaceId) {\n      label\n      completedCount\n      totalCount\n      startedCount\n      ...WorkspaceRoutineStatusOverviewListItem_dimension\n      id\n    }\n    id\n  }\n}\n\nfragment WorkspaceRoutineStatusOverviewListItem_dimension on RoutineWorkspaceCompletionDimension {\n  id\n  label\n  completedCount\n  totalCount\n  startedCount\n}\n"
  }
};
})();

(node as any).hash = "618c694d5d2f4173f6d5cad263f1c60a";

export default node;
